import { createFileRoute, redirect } from "@tanstack/react-router";
import { signOut } from "aws-amplify/auth";

export const Route = createFileRoute("/logout")({
  beforeLoad: async () => {
    try {
      await signOut();
    } catch {
      /* ignore */
    }
    throw redirect({ to: "/login" });
  },
  component: () => null,
});
